<div kalDialogContent
     [kalLoading]="loading"
     *ngIf="data.mail as mail">

    <kal-form-field>

        <kal-input label="À"
                   [formControl]="destinationMailFormControl">
        </kal-input>

    </kal-form-field>

    <p><strong>Objet : </strong> {{ mail.subject }}</p>

    <br>

    <div class="gup-U-strong">Contenu :</div>

    <p [innerHTML]="mail.content | sanitize: 'html'">
    </p>

    <ng-container *ngIf="mail.vouchersList | arrayNotEmpty">

        <div class="gup-U-strong">Pièces jointes :</div>

        <div *ngFor="let voucher of mail.vouchersList">

            <a [href]="voucher.Url"
               target="_blank">
                <kal-icon>attach_file</kal-icon>
                {{ voucher.Filename }}
            </a>

        </div>

    </ng-container>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="sendMail()"
                        [disabled]="loading || destinationMailFormControl.invalid"
                        kalTheme="primary">
                Envoyer
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()"
                        [disabled]="loading"
                        kalTheme="secondary">
                Fermer
            </kal-button>

        </div>

    </div>

</div>
